export const CHANNEL_OPTIONS = [
    { key: 1, text: 'OpenAI', value: 1, color: 'green' },
    { key: 14, text: 'Anthropic Claude', value: 14, color: 'black' },
    { key: 33, text: 'AWS', value: 33, color: 'black' },
    { key: 3, text: 'Azure OpenAI', value: 3, color: 'olive' },
    { key: 11, text: 'Google PaLM2', value: 11, color: 'orange' },
    { key: 24, text: 'Google Gemini', value: 24, color: 'orange' },
    { key: 28, text: 'Mistral AI', value: 28, color: 'orange' },
    { key: 41, text: 'Novita', value: 41, color: 'purple' },
    { key: 40, text: '字节跳动豆包', value: 40, color: 'blue' },
    { key: 15, text: '百度文心千帆', value: 15, color: 'blue' },
    { key: 17, text: '阿里通义千问', value: 17, color: 'orange' },
    { key: 18, text: '讯飞星火认知', value: 18, color: 'blue' },
    { key: 16, text: '智谱 ChatGLM', value: 16, color: 'violet' },
    { key: 19, text: '360 智脑', value: 19, color: 'blue' },
    { key: 25, text: 'Moonshot AI', value: 25, color: 'black' },
    { key: 23, text: '腾讯混元', value: 23, color: 'teal' },
    { key: 26, text: '百川大模型', value: 26, color: 'orange' },
    { key: 27, text: 'MiniMax', value: 27, color: 'red' },
    { key: 29, text: 'Groq', value: 29, color: 'orange' },
    { key: 30, text: 'Ollama', value: 30, color: 'black' },
    { key: 31, text: '零一万物', value: 31, color: 'green' },
    { key: 32, text: '阶跃星辰', value: 32, color: 'blue' },
    { key: 34, text: 'Coze', value: 34, color: 'blue' },
    { key: 35, text: 'Cohere', value: 35, color: 'blue' },
    { key: 36, text: 'DeepSeek', value: 36, color: 'black' },
    { key: 37, text: 'Cloudflare', value: 37, color: 'orange' },
    { key: 38, text: 'DeepL', value: 38, color: 'black' },
    { key: 39, text: 'together.ai', value: 39, color: 'blue' },
    { key: 42, text: 'VertexAI', value: 42, color: 'blue' },
    { key: 43, text: 'Proxy', value: 43, color: 'blue' },
    { key: 44, text: 'SiliconFlow', value: 44, color: 'blue' },
    { key: 45, text: 'xAI', value: 45, color: 'blue' },
    { key: 46, text: 'Replicate', value: 46, color: 'blue' },
    { key: 8, text: '自定义渠道', value: 8, color: 'pink' },
    { key: 22, text: '知识库：FastGPT', value: 22, color: 'blue' },
    { key: 21, text: '知识库：AI Proxy', value: 21, color: 'purple' },
    { key: 20, text: '代理：OpenRouter', value: 20, color: 'black' },
    { key: 2, text: '代理：API2D', value: 2, color: 'blue' },
    { key: 5, text: '代理：OpenAI-SB', value: 5, color: 'brown' },
    { key: 7, text: '代理：OhMyGPT', value: 7, color: 'purple' },
    { key: 10, text: '代理：AI Proxy', value: 10, color: 'purple' },
    { key: 4, text: '代理：CloseAI', value: 4, color: 'teal' },
    { key: 6, text: '代理：OpenAI Max', value: 6, color: 'violet' },
    { key: 9, text: '代理：AI.LS', value: 9, color: 'yellow' },
    { key: 12, text: '代理：API2GPT', value: 12, color: 'blue' },
    { key: 13, text: '代理：AIGC2D', value: 13, color: 'purple' }
];

/**
 * 各渠道类型「内置的接口地址」。
 *
 * 这份表是给界面显示用的：渠道编辑弹窗里要能看见「这个渠道现在实际会请求哪个地址」，
 * 而不是留一个空白框让人猜。
 *
 * 必须与后端 relay/channeltype/url.go 的 ChannelBaseURLs 逐项一致 ——
 * 那边是数组、下标即渠道类型；这里写成对象，键就是渠道类型，读起来不会错位。
 * 后端的行为是：渠道里填了 base_url 就用渠道的，没填才回落到这张表。
 *
 * 空字符串表示「该类型没有内置地址」（由 One API 内部按区域/项目拼，或必须自己填）。
 */
export const CHANNEL_BASE_URLS = {
  1: 'https://api.openai.com',
  2: 'https://oa.api2d.net',
  4: 'https://api.closeai-proxy.xyz',
  5: 'https://api.openai-sb.com',
  6: 'https://api.openaimax.com',
  7: 'https://api.ohmygpt.com',
  9: 'https://api.caipacity.com',
  10: 'https://api.aiproxy.io',
  11: 'https://generativelanguage.googleapis.com',
  12: 'https://api.api2gpt.com',
  13: 'https://api.aigc2d.com',
  14: 'https://api.anthropic.com',
  15: 'https://aip.baidubce.com',
  16: 'https://open.bigmodel.cn',
  17: 'https://dashscope.aliyuncs.com',
  19: 'https://ai.360.cn',
  20: 'https://openrouter.ai/api',
  21: 'https://api.aiproxy.io',
  22: 'https://fastgpt.run/api/openapi',
  23: 'https://hunyuan.tencentcloudapi.com',
  24: 'https://generativelanguage.googleapis.com',
  25: 'https://api.moonshot.cn',
  26: 'https://api.baichuan-ai.com',
  27: 'https://api.minimax.chat',
  28: 'https://api.mistral.ai',
  29: 'https://api.groq.com/openai',
  30: 'http://localhost:11434',
  31: 'https://api.lingyiwanwu.com',
  32: 'https://api.stepfun.com',
  34: 'https://api.coze.com',
  35: 'https://api.cohere.ai',
  36: 'https://api.deepseek.com',
  37: 'https://api.cloudflare.com',
  38: 'https://api-free.deepl.com',
  39: 'https://api.together.xyz',
  40: 'https://ark.cn-beijing.volces.com',
  41: 'https://api.novita.ai/v3/openai',
  44: 'https://api.siliconflow.cn',
  45: 'https://api.x.ai',
  46: 'https://api.replicate.com/v1/models/'
};

/** 取某个渠道类型的内置接口地址；没有内置地址时返回 ''（不是 undefined，调用方不用再判空）。 */
export const getDefaultBaseURL = (type) => CHANNEL_BASE_URLS[type] || '';
